import { useContext, useState, useCallback, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate, useLocation } from "react-router-dom";

import Header from "../Header/Header";
import HeaderLogin from "../CoursePage/HeaderLogin/HeaderLogin";
import Main from "../MainPage/Main/Main";
import Footer from "../Footer/Footer";
import Promo from "../MainPage/Promo/Promo";
import Menu from "../Menu/Menu";
import JsonLd from "../SEO/JsonLd";
import CallbackButton from "../CallbackButton/CallbackButton";

import { CurrentUserContext } from "../../contexts/CurrentUserContext";

function HomeRouter({ isLogin, isReadyApp, exitLogin, isUnit }) {
  const { currentUser } = useContext(CurrentUserContext);
  const location = useLocation();

  const [isOpenMenu, setOpenMenu] = useState(false);
  const openMenu = useCallback(() => setOpenMenu(true), []);
  const closeMenu = useCallback(() => setOpenMenu(false), []);
  const toggleMenu = useCallback(() => setOpenMenu((v) => !v), []);

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace("#", "");
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (!el) return false;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return true;
    };

    if (scrollToTarget()) return;

    const timer = setTimeout(scrollToTarget, 250);
    return () => clearTimeout(timer);
  }, [location.hash, isReadyApp]);

  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: "Школа конструктора-технолога мебели",
    url: "https://kt-mebel.ru/",
    logo: "https://kt-mebel.ru/icons/icon-512-v3.png",
      founder: {
    "@type": "Person",
    name: "Тарасов Евгений"
  }
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "Кому подходят курсы школы конструктора-технолога мебели?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Курсы подходят людям без опыта которые хотят сменить свою профессию, смежных профессий, которые хотят освоить профессию конструктора-технолога мебели.",
        },
      },
      {
        "@type": "Question",
        name: "Как проходит обучение?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Онлайн-формат: видеоматериалы, методички, практические задания и поддержка наставников. Доступ из личного кабинета в любое время.",
        },
      },
      {
        "@type": "Question",
        name: "Нужен ли опыт и мощный компьютер?",
        acceptedAnswer: {
          "@type": "Answer",
          text:
            "Подходит без опыта. Для выполнения заданий достаточно современного ПК и стабильного интернета.",
        },
      },
    ],
  };

  if (!isReadyApp) {
    return <div>Загрузка...</div>;
  }

  // ---------------- ПУБЛИЧНАЯ ГЛАВНАЯ ----------------
  if (!isLogin) {
    return (
      <>
        <Helmet>
          <title>Обучение проектированию мебели онлайн</title>
          <meta
            name="description"
            content="Онлайн-обучение проектированию корпусной мебели с нуля. Практика, программа БАЗИС и поддержка эксперта для будущих конструкторов мебели."
          />
          <link rel="canonical" href="https://kt-mebel.ru/" />

          <meta property="og:locale" content="ru_RU" />
          <meta property="og:type" content="website" /> 
          <meta property="og:url" content="https://kt-mebel.ru/" />
          <meta
            property="og:title"
            content="Школа КТМ — онлайн обучение мебельному проектированию"
          />
          <meta
            property="og:description"
            content="Практические курсы: проектирование мебели. Онлайн-формат, поддержка экспертов, доступ из личного кабинета."
          />
          <meta
            property="og:image"
            content="https://kt-mebel.ru/og-image.jpg"
          />

          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>

        {/* JSON-LD всегда ВНЕ Helmet */}
        <JsonLd data={orgJsonLd} />
        <JsonLd data={faqJsonLd} />

        <Header
          isOpenMenu={isOpenMenu}
          openMenu={openMenu}
          closeMenu={closeMenu}
          toggleMenu={toggleMenu}
        />
        <Main isUnit={isUnit} />
        <Footer />
        <Menu isOpenMenu={isOpenMenu} closeMenu={closeMenu} />
        <CallbackButton />

      </>
    );
  }

  // ---------------- НЕАКТИВИРОВАН ----------------
  if (!currentUser?.isActivated) {
    return <Navigate to="/confirmation" replace />;
  }

  // ---------------- АВТОРИЗОВАН ----------------
  return (
    <>
      <Helmet>
        <title>Школа конструктора-технолога</title>
        <meta name="robots" content="noindex,follow" />
        <link rel="canonical" href="https://kt-mebel.ru/" />
      </Helmet>

      <HeaderLogin exitLogin={exitLogin} />
      <Promo isLogin={isLogin} />
      <Footer isLogin={isLogin} />
      <CallbackButton />
    </>
  );
}

export default HomeRouter;
